import { useState } from "react";
import { Navigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/site/Wordmark";
import { Spinner } from "@/components/site/Primitives";

export default function Login() {
  const { user, setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try { setUser((await api.post("/auth/login", { email, password })).data); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#050505]" data-testid="admin-login-page">
      <div className="hidden lg:flex flex-col justify-between p-12 border-r border-[#27272A] relative overflow-hidden">
        <div className="absolute -left-40 bottom-0 w-[500px] h-[500px] bg-[#0055FF]/15 blur-[140px]" />
        <Wordmark size="text-3xl" />
        <p className="relative font-display text-6xl font-black uppercase tracking-tighter leading-[0.9]">Studio<br />control<br />room.</p>
        <p className="text-xs text-zinc-600">Authorised EditBay staff only.</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="admin-login-form">
          <div className="lg:hidden mb-8"><Wordmark /></div>
          <h1 className="text-3xl font-bold">Staff sign-in</h1>
          <label className="block space-y-1.5"><span className="text-sm text-zinc-400">Email</span>
            <input className="eb-input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" /></label>
          <label className="block space-y-1.5"><span className="text-sm text-zinc-400">Password</span>
            <input className="eb-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" /></label>
          {error && <p className="text-sm text-[#FF3B30]" role="alert" data-testid="login-error">{error}</p>}
          <button className="eb-btn-primary w-full" disabled={busy} data-testid="login-submit">{busy && <Spinner />}Sign in</button>
          <div className="flex items-center gap-3 text-xs text-zinc-600"><span className="h-px flex-1 bg-[#27272A]" />or<span className="h-px flex-1 bg-[#27272A]" /></div>
          <button type="button" onClick={google} className="eb-btn-ghost w-full" data-testid="login-google">Continue with Google</button>
          <p className="text-xs text-zinc-600">Google sign-in works only for emails on the staff allow-list.</p>
        </form>
      </div>
    </div>
  );
}
